import sample_1 from './casual.jpg';

export const casualImpressions = {
    sample_1,
};
